import { useTheme, useMediaQuery, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { FormatQuote } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import leftPic from "../../../images/Ghorami home/cm-16.png";
import Slider from "react-slick";
import { motion } from "framer-motion";
import RightContent from "./RightContent";
import { testimonialApi } from "../../API/Api";
import { tokens } from "../../../store/tokens";

const Testimonial = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    fetch(testimonialApi)
      .then((res) => res.json())
      .then((result) => {
        setTestimonialData(result);
      })
      .catch((error) => console.log("testimonial error => ", error));
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    adaptiveHeight: true,
    fade: true,
  };

  return (
    <Box
      sx={{
        bgcolor: tokens.banner.dark.background,
        mt: 0,
        py: { xs: 5, md: 8 },
        px: { xs: 2, md: 6 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "70vh",
          bgcolor: "rgba(18,36,46,0.85)",
          backgroundImage:
            "radial-gradient(circle at 20% 30%, rgba(15,139,141,0.35), transparent 70%), radial-gradient(circle at 80% 70%, rgba(15,111,185,0.28), transparent 70%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      <Stack spacing={{ xs: 3, md: 5 }} sx={{ position: "relative", zIndex: 2 }}>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          sx={{ textAlign: "center" }}
        >
          <Typography
            sx={{
              fontFamily: tokens.font.body,
              fontSize: "0.75rem",
              fontWeight: 700,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: tokens.textOn.dark.brand,
            }}
          >
            Testimonials
          </Typography>
          <Typography
            sx={{
              fontFamily: tokens.font.heading,
              fontSize: { xs: "1.4rem", md: "1.8rem" },
              fontWeight: 700,
              color: tokens.textOn.dark.primary,
              mt: 0.5,
            }}
          >
            What freelancers say about us
          </Typography>
        </Box>

        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="center"
          alignItems="center"
          spacing={{ xs: 4, md: 0 }}
        >
          {!isMobile && (
            <Box
              component={motion.img}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              src={leftPic}
              alt="Freelancer testimonial illustration"
              sx={{
                width: "60%",
                maxWidth: 500,
                borderRadius: `${tokens.radius.lg}px`,
                filter: "drop-shadow(0 0 12px rgba(15,139,141,0.5))",
                userSelect: "none",
                flexShrink: 0,
              }}
            />
          )}

          <Box
            component={motion.div}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
            sx={{
              position: "relative",
              width: { xs: "100%", md: "50%" },
              maxWidth: 600,
              backdropFilter: "blur(12px)",
              backgroundColor: "rgba(255, 255, 255, 0.07)",
              border: "1px solid rgba(255, 255, 255, 0.12)",
              borderRadius: `${tokens.radius.lg}px`,
              boxShadow: tokens.shadow.lg,
              p: { xs: 3, md: 4 },
              pb: { xs: 5, md: 6 },
              // Slick's default dots render as tiny black bullets — nearly
              // invisible against this dark, blurred card — so restyle
              // them to match the brand accent instead.
              "& .slick-dots": {
                bottom: -6,
              },
              "& .slick-dots li button:before": {
                fontSize: 8,
                color: "rgba(255,255,255,0.35)",
                opacity: 1,
              },
              "& .slick-dots li.slick-active button:before": {
                color: tokens.textOn.dark.brand,
              },
            }}
          >
            <FormatQuote
              sx={{
                position: "absolute",
                top: { xs: 12, md: 18 },
                left: { xs: 16, md: 22 },
                fontSize: { xs: "2rem", md: "2.5rem" },
                color: "rgba(255,255,255,0.12)",
                transform: "scaleX(-1)",
              }}
            />

            <Slider {...settings}>
              {testimonialData.map((element) => (
                <Box key={element.refer} sx={{ outline: "none" }}>
                  <RightContent testimonialData={element} />
                </Box>
              ))}
            </Slider>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Testimonial;